import script from "./FuelReceiptTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FuelReceiptTable.vue?vue&type=script&setup=true&lang=js"

import "./FuelReceiptTable.vue?vue&type=style&index=0&id=fc04c72c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc04c72c"]])

export default __exports__